import { Box } from "@mui/material";
import { alpha, type Theme } from "@mui/material/styles";
import type { JSX, ReactNode } from "react";

/** Small shared pills for the Agent Status cards, extracted from `StatusPage.tsx`. */

export function Chip({
  children,
  tint,
}: {
  children: ReactNode;
  tint?: (t: Theme) => string;
}): JSX.Element {
  const color = tint ?? ((t: Theme) => t.palette.primary.main);
  return (
    <Box
      component="span"
      sx={{
        borderRadius: 999,
        px: 1,
        py: 0.25,
        fontSize: 12,
        fontWeight: 600,
        bgcolor: (t) => alpha(color(t), 0.12),
        color: (t) => color(t),
        whiteSpace: "nowrap",
      }}
    >
      {children}
    </Box>
  );
}

export function RunPill({ status }: { status: string }): JSX.Element {
  const tint = (t: Theme): string => {
    switch (status) {
      case "ok":
        return t.palette.success.main;
      case "failed":
        return t.palette.error.main;
      case "running":
        return t.palette.info.main;
      default:
        return t.palette.text.secondary;
    }
  };
  return (
    <Box
      component="span"
      sx={{
        borderRadius: 999,
        px: 0.75,
        py: 0.125,
        fontSize: 10,
        fontWeight: 600,
        textTransform: "uppercase",
        letterSpacing: "0.04em",
        bgcolor: (t) => alpha(tint(t), 0.16),
        color: (t) => tint(t),
      }}
    >
      {status}
    </Box>
  );
}
